<template>
  <ValidationObserver ref="rejectOfferValidation">
    <BaseDialog isOpen>
      <template v-slot:title>
        Why do you want to reject the offer?
      </template>
      <template v-slot:body>
        <div class="secondary-text">
          You must provide a reason, but this will only be visible internally
        </div>
        <ValidationProvider v-slot="{ errors }" name="reason" rules="required">
          <v-textarea
            :error-messages="showValidationErrors ? errors : ''"
            v-model="reason"
            required
            class="mt-2"
          />
        </ValidationProvider>
      </template>
      <template v-slot:actions>
        <div>
          <PrimaryButton @click.native="cancel" text>
            Cancel
          </PrimaryButton>
          <ErrorButton @click.native="handleSubmit" :loading="isLoading">
            Reject Offer
          </ErrorButton>
        </div>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import {
  REJECT_OFFER,
  ADD_OFFER_COMMENT
} from "@/store/modules/offers/actions";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const { mapActions: mapOfferActions } = createNamespacedHelpers(
  OFFERS_NAMESPACE
);

export default {
  name: "RejectOfferDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    ErrorButton,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      showValidationErrors: false,
      isLoading: false,
      reason: ""
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapOfferActions({
      rejectOffer: REJECT_OFFER,
      addComment: ADD_OFFER_COMMENT
    }),
    async handleSubmit() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.rejectOfferValidation.validate();
      if (isFormValid) {
        this.isLoading = true;
        await this.rejectOffer(this.currentOfferId);
        await this.addComment({
          body: this.reason,
          commentableType: "offer",
          commentableId: this.currentOfferId
        });
        this.cancel();
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
